import { useQuery } from "@tanstack/react-query";

import { optimizationsQuery } from "#modules/optimizations/infra/optimizations.query";

export const useOptimizations = ({
  quoteRequestId,
  enabled,
}: {
  quoteRequestId: string;
  enabled: boolean;
}) => {
  const { data, ...rest } = useQuery({
    ...optimizationsQuery({ quoteRequestId }),
    enabled,
  });

  return { optimizations: data, ...rest };
};
